import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '.';
import { ContinueConfirmationComponent } from '../common_components/continue-confirmation/continue-confirmation.component';
import { ToasterComponent } from '../common_components/toaster/toaster.component';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  roleCode:any;
  selectedLang:any;
  objRoleMst:any;
  objMembView:any;
  screenData:any;
  blkId:any;
  pgDetailValue:any;
  prodMasterValue:any;
  enablePlusIcon = false;
  objFunddis:any;
  fromPage:string;
  pwdresetflags:string;
  havefileAttachement:boolean;
  attachmentData:any;
  canShowPopUp:any;
  AggProducedetails:any;
  path = {attachPath:""};
  BusinessPlanData:any;
  MasterData:any;
  MasterDataDetails:any;

  getPgDetails:any;
    constructor(
        private api: ApiService, public dialog: MatDialog,
      ) { }

  getScreenData(ScreenCode: String): any {
            this.api.post(`/Getscreendata?screenCode=${ScreenCode}`, {}).subscribe((res:any)=>{
              this.screenData = res;
              return this.screenData;
            });
          }


toaster(mode:string, msg:string){
  const dialogRef = this.dialog.open(ToasterComponent, {
    width: '440px',
    height: 'auto',
    disableClose: true,
    panelClass: 'full-screen-popup',
    data: {
      mode: mode,
      msg: msg,
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result == true) {
      this.canShowPopUp = null;
      return true;
    }
  });
}

continueToaster(mode:string, msg:string) {
  const dialogRef = this.dialog.open(ContinueConfirmationComponent, {
    width: '440px',
    height: 'auto',
    disableClose: true,
    panelClass: 'full-screen-popup',
    data: {
      mode: mode,
      msg: msg,
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result == true) {
      this.canShowPopUp = null;
      return true;
    } else {
      this.canShowPopUp = null;
      this.dialog.closeAll();
    }
  });
}

}